module.exports = __webpack_public_path__ + "img/word-cloud.ee1a1dcc.png";